import type { PropsWithChildren } from 'react';
import { Layout, Spin, Alert } from 'antd';
import BaseSider from './components/BaseSider';
import { LocalizedText } from '../components/i18n/LocalizedText';
import { Helmet } from 'react-helmet';
import { useLayoutStyles } from './styles';
import { Flex } from '~/components/Flex';

const { Content, Footer } = Layout;
const { ErrorBoundary } = Alert;

export const CommonLayout = ({
  children,
  header,
  title,
  pageLoading,
  hideSidebar,
  hideFooter,
  flexibleWidth = false,
}: PropsWithChildren<{
  header: React.ReactNode;
  title: string;
  pageLoading: boolean;
  hideSidebar?: boolean;
  hideFooter?: boolean;
  flexibleWidth?: boolean;
}>) => {
  const year = new Date().getFullYear();
  const classes = useLayoutStyles();

  return (
    <Layout className={classes.layout}>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{title}</title>
        <link rel="canonical" />
      </Helmet>
      {!hideSidebar && <BaseSider />}
      <Layout className={classes.layout}>
        {header}
        <Content className={classes.content}>
          <Spin spinning={pageLoading} wrapperClassName={classes.contentBody}>
            <ErrorBoundary>
              <Flex direction="vertical" maxWidth={flexibleWidth ? 'unset' : 1400} justifySelf="center">
                {children}
              </Flex>
            </ErrorBoundary>
          </Spin>
          {!hideFooter && (
            <Footer className={classes.footer}>
              <LocalizedText token="layout.footer.copyright" /> © {year}
            </Footer>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};
